var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CasesMaterial',{staticClass:"my-2 cases-material-full-width",attrs:{"material":_vm.module.html,"newCase":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }